<template>
    <div class="navbar">
        <div class="left-menu">
            <Hamburger :toggleClick="handleToggleSideBar" :isActive="sidebarOpened" />
            <Breadcrumb v-if="layoutType == 'old'" />
            <div v-if="layoutType === 'new'">
                <UserPortal :key="loadTimerUserPortal" :appState="appState" :menuData="menuData"
                    :applicationList="applicationList" :defaultAppId="selectAppId" @handleMenuChange="handleMenuChange"
                    @navWorkMenu="navWorkMenu" @handleConsole="handleConsole" @handleNavApplicaion="handleNavApplicaion"
                    @handleDashBoradCenter="handleDashBoradCenter" />
            </div>
        </div>
        <div v-if="isShowNewMenu" class="center-menu">
            <div class="menu-system">
                <div class="menu-system-item" v-for="(item, index) in menuDataList" :key="index"
                    @click.stop="jumpParentUrl(item)" v-if="item.sonMenu.length > 0">
                    <div class="menu-system-item-tit" :style="'color:' + item.meta.color + ','">
                        {{ item.meta.title }}
                    </div>
                    <div class="menu-system-item-child"
                        v-if="item.name !== 'process' && item.name !== 'operation' && item.name !== 'application'">
                        <div class="menu-system-child" v-for="(obj, ind) in item.sonMenu" :key="ind"
                            @click.stop="jumpUrl(obj)">
                            <i :class="obj.meta.icon" :style="'color:' + obj.meta.color + ';'"></i>{{ obj.meta.title }}
                        </div>
                    </div>
                    <div class="menu-system-item-child-group" v-else>
                        <div class="menu-system-child" v-for="(obj, ind) in item.sonMenu" :key="ind"
                            v-if="isShowMenuItem(obj)">
                            <i :class="obj.meta.icon" :style="'color:' + obj.meta.color + ';'"></i>{{ obj.meta.title }}
                            <div class="menu-system-child-item" v-for="(child, c) in obj.children" :key="c"
                                @click.stop="jumpUrl(child)">
                                <i :class="child.meta.icon" :style="'color:' + child.meta.color + ';'"></i>{{
                                        child.meta.title
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-menu">
            <span>
                <el-badge v-if="isShowUpgradeBtn" is-dot :hidden="upgrade" class="item">
                    <el-tooltip effect="dark" content="升级申请" placement="top">
                        <el-button class="share-button" icon="el-icon-thumb" type="primary"
                            @click="handleUpgradeApply()" circle></el-button>
                    </el-tooltip>
                </el-badge>
             </span>
             <span>
             </span>
             <span class="item">
               <el-tooltip effect="dark" content="帮助" placement="top">
                  <el-button class="share-button" type="success" icon="el-icon-question" @click="handleHelp()" circle></el-button>
              </el-tooltip>
             </span>
             <!-- <span class="item">
               <el-tooltip effect="dark" content="商店" placement="top">
                  <el-button class="share-button" type="success" icon="el-icon-goods" @click="handleAppStore()" circle></el-button>
              </el-tooltip>
             </span> -->
             <span class="userName">
                {{userInfo.trueName}}
             </span>
            <el-dropdown class="avatar-container right-menu-item" trigger="click">
                <div class="avatar-wrapper">
                    <img v-if="imageUrl" :src="imageUrl" class="user-avatar">
                    <i class="el-icon-caret-bottom" />
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>{{ userInfo.trueName }}</el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleBaseInfoSetting">个人基本信息</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleSwitchLayout">{{ switchLayoutFlg ? '切换至旧版布局' :
                                '切换至新版布局'
                        }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleUpdPwd">密码设置</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleUpdFirstPage"
                            v-if="userInfo.switchLayoutFlg == 2">首页设置</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="handleLogout">退出</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <el-dialog :visible.sync="isShowUpgradeDialog" title="版本升级信息确认" fullscreen top="4vh" width="90%" center
            append-to-body>
            <UpgradePop ref="upgradePop" :userInfo="userInfo" />
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import jsCookies from 'js-cookie';
import UpgradePop from '@/components/UpgradePop';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import UserPortal from '@/components/UserPortal';
import mixinsNav from '@/mixins/mixins-nav';
import {
    getWarnMessageList, getMessageList, loginOut, upgradeSysApply, getPublishedApplicationList, changeSwitchLayoutFlg,
    updateWorkPlantEntry, getUserWorkPlantEntry, getModelListByType
} from '@/data-model';
import * as constants from '@/common/constants';
import { getGlobalConf } from '@/utils/grocer';
import Draggable from 'vuedraggable';
export default {
    mixins: [mixinsNav],
    components: {
        Hamburger,
        Breadcrumb,
        UpgradePop,
        Draggable,
        UserPortal
    },
    data () {
        return {
            upgradeLoading: false,
            upgradeDes: '',
            isShowUpgradeDialog: false,
            upgrade: true,
            imageUrl: '',
            warnHot: true,
            msgHot: true,
            searchMsgParams: {
                msgType: null, // 消息类型 null全部 0:系统 1流程 2任务 3表单 4档案  5产品 ...
                msgStatus: null // 消息阅读状态 null全部 0未读 1已读
            },
            isShowWarnMessage: true,
            isShowMessage: true,
            isShowUpgradeBtn: false,
            tenantVerionName: '',
            switchLayoutFlg: false,
            isShowNewMenu: false,
            loadTimerUserPortal: '',
            applicationList: [],
            // activeIndex: '1',
            menuDataSource: [],
            isEdit: false,
            allMenu: [],
            positionLeft: '60px',
            permission: {
                isShowProcess: [
                    constants.CONST_NAV_ROUTE_PROCESS
                ],
                isShowDocument: [
                    constants.CONST_NAV_ROUTE_DUCTUMENT
                ],
                isShowOffice: [
                    constants.CONST_NAV_ROUTE_OFFICE
                ],
                isShowOperation: [
                    constants.CONST_NAV_ROUTE_OPERATION
                ],
                isShowMessage: [
                    constants.CONST_NAV_ROUTE_MESSAGE
                ],
                isShowSystem: [
                    constants.CONST_NAV_ROUTE_SYSTEM
                ],
                isShowApplication: [
                    constants.CONST_NAV_ROUTE_APPLICATION
                ],
                isShowMore: [
                    constants.CONST_NAV_ROUTE_MESSAGE,
                    constants.CONST_NAV_ROUTE_SYSTEM,
                    constants.CONST_NAV_ROUTE_APPLICATION
                ]
            },
            appContentOpts: {
                group: {
                    name: 'appContent',
                    put: ['formToolbar']
                },
                sort: true
            },
            selectAppId: 0,
            menuDataList: []
        };
    },
    props: {
        appState: {
            type: Object
        },
        userInfo: {
            type: Object
        },
        menuData: {
            type: Array
        },
        isShowHamburger: {
            type: Boolean,
            default: true
        },
        isShowLeft: {
            type: String,
            default: '1'
        },
        activeIndex: {
            type: String,
            default: '1'
        }
    },
    watch: {
        async isShowNewMenu (val) {
            if (val) {
                let apps = await getPublishedApplicationList();
                this.applicationList = apps;
                this.loadTimerUserPortal = new Date().getTime();
            }
        },
        workPlantEntry (newVal, oldVal) {
            if (newVal) {
                this.menuDataSource = cloneDeep(newVal);
                this.initAllMenu();
            }
        },
        sidebarOpened (newVal, oldVal) {
            if (newVal) {
                this.positionLeft = '220px';
            } else {
                this.positionLeft = '60px';
            }
        },
        routers (val) {
            if (val.length > 0) {
                this.builderMenuData(val);
            }
        }
    },
    computed: {
        sidebarOpened () {
            return this.appState.sidebar.opened;
        },
        ...mapGetters([
            'workPlantEntry',
            'showLeft',
            'layoutType',
            'routers'
        ])
    },
    created () {
        this._initPage();
        this.menuDataSource = cloneDeep(this.workPlantEntry);
        this.initAllMenu();
        if (this.routers.length > 0) {
            this.builderMenuData(this.routers);
        }
        // console.log(this.routers);
        // this.builderMenuData(this.routers);
    },
    methods: {
        ...mapActions([
            constants.VUEX_ACTIONS_WORK_PLANT_ENTRY,
            constants.VUEX_ACTIONS_NAV_SHOW_LEFT,
            constants.VUEX_ACTIONS_LAYOUT_TYPE
        ]),
        async _initPage () {
            if (this.userInfo) {
                if ((this.userInfo.companyInfo.hasOwnProperty('isPay') && this.userInfo.companyInfo.isPay === 0) || (this.userInfo.companyInfo.companyResource.resourceVersion & 2) > 0) {
                    this.isShowUpgradeBtn = true;
                    this.isShowWarnMessage = false;
                } else {
                    await this.setWarnMessageHot();
                }
                if ((this.userInfo.companyInfo.companyResource.resourceVersion & 4) > 0) {
                    this.tenantVerionName = '企业版';
                } else if ((this.userInfo.companyInfo.companyResource.resourceVersion & 1) > 0) {
                    this.tenantVerionName = '免费版';
                } else if ((this.userInfo.companyInfo.companyResource.resourceVersion & 2) > 0) {
                    this.tenantVerionName = '体验版';
                }
                await this.setMessageHot();
                let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                let currentUser = JSON.parse(currentUserStr);
                if ((this.userInfo.companyInfo.companyResource.resourceVersion & 4) > 0 && currentUser.switchLayoutFlg === 2) {
                    this.switchLayoutFlg = true;
                    this.isShowNewMenu = true;
                    this[constants.VUEX_ACTIONS_LAYOUT_TYPE]('new');
                    let isNewPageInitLoad = window.localStorage.getItem('isNewPageInitLoad' + currentUser.userId);
                    if (isNewPageInitLoad !== '1') {
                        if (this.menuData && this.menuData.length > 0) {
                            window.localStorage.setItem('isNewPageInitLoad' + currentUser.userId, '1');
                            let currentPath = this.menuData[0].id;
                            this.handleNavPage('workspace', currentPath);
                        }
                    } else {
                        let currentPath = this.$route.path;
                        let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                        if (currentPath.indexOf(ROUTER_BASE_PATH) !== -1) {
                            currentPath = currentPath.replace(ROUTER_BASE_PATH, '');
                        }
                        let endIdx = currentPath.indexOf('/', currentPath.indexOf('/') + 1);
                        let newTarget = currentPath.substring(1, endIdx);
                        this.handleNavPageInit(newTarget, currentPath, 1);
                    }
                }
            }
            this.setUserPic();
        },
        isShowMenuItem (obj) {
            if (obj.meta) {
                return true;
            } else {
                return false;
            }
        },
        handleToggleSideBar () {
            this.$emit('toggleSideBar');
        },
        async setMessageHot () {
            // 查询未读消息
            this.searchMsgParams.msgStatus = 0;
            let unReadMsgData = await getMessageList(Object.assign({}, {
                currentPage: 0,
                pageSize: 10
            }, this.searchMsgParams));
            if (unReadMsgData) {
                if (unReadMsgData.totalPageNum > 0) {
                    this.msgHot = false;
                } else {
                    this.msgHot = true;
                }
            }
        },
        async setWarnMessageHot () {
            // 查询未读消息
            this.searchMsgParams.msgStatus = 0;
            // 查询预警消息未读总数
            let warnMsgData = await getWarnMessageList(Object.assign({}, {
                currentPage: 0,
                pageSize: 10
            }, this.searchMsgParams));
            if (warnMsgData && warnMsgData.totalPageNum > 0) {
                this.warnHot = false;
            } else {
                this.warnHot = true;
            }
        },
        async handleLogout () {
            window.localStorage.clear();
            await loginOut();
            window.localStorage.clear();
            window.sessionStorage.removeItem('currentUserType');
            window.sessionStorage.removeItem('currentUserInfo');
            window.localStorage.removeItem('currentUserInfo');
            window.sessionStorage.removeItem('isNewPageInitLoad');
            jsCookies.remove('JSESSIONID');
            this.navLogin();
        },
        setUserPic () {
            let prefix = '';
            let env = process.env.NODE_ENV;
            if (env === 'production') {
                prefix = '/bcbpm';
            }
            if (this.userInfo.userPic) {
                if (this.userInfo.userPic.startsWith('/images')) {
                    this.imageUrl = prefix + this.userInfo.userPic;
                } else {
                    this.imageUrl = `${constants.API_IMG_DOWNLOAD}${this.userInfo.userPic}`;
                }
            } else {
                this.imageUrl = prefix + '/images/default.png';
            }
        },
        handleUpgradeApply () {
            if (this.userInfo.isEnterprise === 1) {
                this.isShowUpgradeDialog = true;
            } else {
                this.messageTip('只有注册账号可以发起申请', 'warning');
            }
        },
        async handleUpgradeApplyOK () {
            this.upgradeLoading = true;
            try {
                await upgradeSysApply();
            } catch (error) {
                console.error('发起申请失败', error);
            } finally {
                this.isShowUpgradeDialog = false;
                this.upgradeLoading = false;
            }
        },
        handleMyWarnMessage () {
            this.navMyWarnMessage();
        },
        handleMessage () {
            this.navMyMessage();
        },
        handleUpdPwd () {
            this.navUpdPwd();
        },
        handleUpdFirstPage () {
            this.navUpdFirstPage();
        },
        handleBaseInfoSetting () {
            this.navBaseInfoSetting();
        },
        handleHelp () {
            var url = '/forhelp';
            if (window.location.href.indexOf('#/') > -1) {
                // 本地访问路径
                url = '#' + url;
            } else {
                url = '/bpm' + url;
            }
            url = 'https://www.bcbpm.com/bpm/forhelp';
            window.open(url);
        },
        handleAppStore () {
            this.navAppStore();
        },
        messageTip (msg, type) {
            this.$message({
                message: msg,
                type: type,
                duration: 3000
            });
        },
        handleConsole () {
            this.handleNavPage('workspace');
            this.$emit('sortMenu');
        },
        handleNavPage (target, initPath, routeName) {
            // if (target === 'process') {
            //     sessionStorage.setItem('toDefaultProcess', true);
            // }
            this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('show');
            sessionStorage.setItem('isShowLeft', '1');
            this.$emit('changeMenu', '/' + target, initPath, routeName);
        },
        handleNavWorkPlant () {
            this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('hidden');
            sessionStorage.setItem('isShowLeft', '2');
            this.$emit('isShowLeftFunc');
            let obj = this.menuDataSource[0];
            let url = obj.id;
            this.$router.push({ name: obj.name, path: `'/'${url}` });
        },
        handleNavPageInit (target, initPath) {
            // console.log(initPath);
            this.$emit('changeMenu', '/' + target, initPath);
        },
        async handleSwitchLayout () {
            let msg = `切换布局需要重新登录，您确定要切换为` + (this.switchLayoutFlg ? `旧版布局` : `新版布局`) + `吗？【注意：第一次切换版本后需要联系管理员分配对应系统的权限】`;
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                if (this.layoutType === 'old') {
                    sessionStorage.setItem('isShowLeft', 2);
                    this.switchLayoutFlg = true;
                    this.isShowNewMenu = true;
                    await changeSwitchLayoutFlg(this.userInfo.userId, (this.switchLayoutFlg ? 2 : 1));
                    sessionStorage.setItem('isNewPageInitLoad', '1');
                    this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('hidden');
                    this[constants.VUEX_ACTIONS_LAYOUT_TYPE]('new');
                    let obj = this.menuDataSource[0];
                    let url = obj.id;
                    this.$router.push({ name: obj.name, path: `'/'${url}` });
                } else {
                    sessionStorage.setItem('isShowLeft', 1);
                    this.switchLayoutFlg = false;
                    this.isShowNewMenu = false;
                    await changeSwitchLayoutFlg(this.userInfo.userId, (this.switchLayoutFlg ? 2 : 1));
                    sessionStorage.removeItem('isNewPageInitLoad');
                    this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('show');
                    this[constants.VUEX_ACTIONS_LAYOUT_TYPE]('old');
                }
                this.handleLogout();
            }).catch(() => { });
        },
        handleNavApplicaion (app) {
            localStorage.setItem('defaultAppId', app.id);
            this.selectAppId = app.id;
            var url = '/businessSystem';
            this.navigateNameTo(url, 'businessSystem');
            // if (window.location.href.indexOf('#/') > -1) {
            //     // 本地访问路径
            //     url = '#' + url;
            // } else {
            //     url = '/bpm' + url;
            // }
            // window.location.href = url;
        },
        handleDashBoradCenter (obj) {
            var url = '/dashBoradCenter';
            if (window.location.href.indexOf('#/') > -1) {
                // 本地访问路径
                url = '#' + url;
            } else {
                url = '/bpm' + url;
            }
            window.location.href = url;
        },
        navWorkMenu (obj) {
            let url = '/' + obj.id;
            this.$emit('changeMenu', '/workspace', url, obj.name);
        },
        setCommonly () {
            this.isEdit = true;
        },
        closeEdit () {
            this.isEdit = false;
        },
        async updateWorkPlantEntry (obj, type) { // type:1 删除  2新增
            let param = { menuUrl: obj.path, menuId: obj.id, type: type, id: obj.dataId };
            await updateWorkPlantEntry(param);
            this.getUserWorkPlantEntry();
        },
        async getUserWorkPlantEntry () {
            let workPlantEntrys = [];
            let workPlantEntry = await getUserWorkPlantEntry({ mode: this.userInfo.portalMode });
            let chooseMenu = workPlantEntry.data;
            let str = sessionStorage.getItem('noLeftMenu');
            let o = JSON.parse(str);
            let isContainNeedWorkingTask = false;
            for (let i = 0; i < chooseMenu.length; i++) {
                let obj = chooseMenu[i];
                let menu = o.routeWorkbench.find(y => y.id === obj.menuId);
                if (menu) {
                    menu.dataId = obj.id;
                    menu.isShow = true;
                    workPlantEntrys.push(menu);
                }
                if (obj.menuId === 'workspace/needWorkingTask') {
                    isContainNeedWorkingTask = true;
                }
            }
            if (!isContainNeedWorkingTask) {
                let arr = constants.VUEX_WORK_PLANT_ENTRY;
                for (let i = 0; i < arr.length; i++) {
                    arr[i].isShow = true;
                    workPlantEntrys.unshift(arr[i]);
                }
            }
            this[constants.VUEX_ACTIONS_WORK_PLANT_ENTRY](workPlantEntrys);
            this.$emit('sortMenu');
        },
        initAllMenu () {
            let str = sessionStorage.getItem('noLeftMenu');
            let obj = JSON.parse(str);
            let workBench = obj.routeWorkbench;
            let mAll = [];
            for (let j = 0; j < this.menuDataSource.length; j++) {
                let m = this.menuDataSource[j];
                mAll.push(m.id);
            }
            let source = mAll.join(',');
            let wb = [];
            for (let i = 0; i < workBench.length; i++) {
                let o = workBench[i];
                if (source.indexOf(o.id) === -1) {
                    wb.push(o);
                }
            }
            this.allMenu = wb;
        },
        isShowLeftFunc () {
            this.isShowLeft = sessionStorage.getItem('isShowLeft');
        },
        async handleMenuChange () {
            this.$emit('sortMenu');
        },
        builderMenuData (val) {
            this.menuDataList = [];
            let catchObj = {};
            for (let i = 0; i < val.length; i++) {
                let cur = val[i];
                catchObj[cur.name] = cur;
            }
            this.addOtherMenu('1');
            let processTemplate = {// 流程模板
                children: []
            };
            let myApplove = {// 我的审批
                children: []
            };
            let myProcess = {// 我的流程
                children: []
            };
            let myTask = {// 我的任务
                children: []
            };
            let processDesign = {// 流程设计
                children: []
            };
            let processChildren = [];
            if (catchObj.process && catchObj.process.children.length > 0) { // 构造流程瀑布流
                for (let i = 0; i < catchObj.process.children.length; i++) {
                    let cur = catchObj.process.children[i];
                    if (cur.name === 'processDesignTitle') { // 流程设计
                        cur.children = processDesign.children;
                        processDesign = cloneDeep(cur);
                    } else if (cur.name === 'approvalDefinitionDesign' || cur.name === 'processDefinitionDesign' || cur.name === 'time-config' || cur.name === 'close-template') {
                        processDesign.children.push(cur);
                    } else if (cur.name === 'template') {
                        cur.children = processTemplate.children;
                        processTemplate = cloneDeep(cur);
                    } else if (cur.name === 'processTemplateApproval' || cur.name === 'processTemplateProcess') {
                        processTemplate.children.push(cur);
                    } else if (cur.name === 'myApproval') {
                        cur.children = myApplove.children;
                        myApplove = cloneDeep(cur);
                    } else if (cur.name === 'myApprovalApply' || cur.name === 'myApprovalApprove' || cur.name === 'myApprovalCarbonCopy') {
                        myApplove.children.push(cur);
                    } else if (cur.name === 'myProcess') {
                        cur.children = myProcess.children;
                        myProcess = cloneDeep(cur);
                    } else if (cur.name === 'myProcessStartedBy' || cur.name === 'myProcessParticipant' || cur.name === 'myProcessAssignee') {
                        myProcess.children.push(cur);
                    } else if (cur.name === 'myTask') {
                        cur.children = myTask.children;
                        myTask = cloneDeep(cur);
                    } else if (cur.name === 'myTaskAssignee' || cur.name === 'myTaskParticipant') {
                        myTask.children.push(cur);
                    }
                }
                processChildren.push(processTemplate);
                processChildren.push(myApplove);
                processChildren.push(myProcess);
                processChildren.push(myTask);
                catchObj.process.sonMenu = cloneDeep(processChildren);
                this.menuDataList.push(catchObj.process);
            }
            let documentDesign = {// 文档设计
                children: []
            };
            let documentChildren = [];
            if (catchObj.document && catchObj.document.children.length > 0) {
                for (let i = 0; i < catchObj.document.children.length; i++) {
                    let cur = catchObj.document.children[i];
                    if (cur.name === 'archiveDesignTitle') { // 流程设计
                        cur.children = documentDesign.children;
                        documentDesign = cloneDeep(cur);
                    } else if (cur.name === 'archiveTemplate') {
                        documentDesign.children.push(cur);
                    } else {
                        documentChildren.push(cur);
                    }
                }
                this.menuDataList.push(catchObj.document);
                catchObj.document.sonMenu = cloneDeep(documentChildren);
            }
            if (catchObj.office) {
                catchObj.office.sonMenu = cloneDeep(catchObj.office.children);
                this.menuDataList.push(catchObj.office);
            }
            let operationSonMenu = [];
            let operationDesign = {// 企业运营分析
                children: []
            };
            if (catchObj.operation && catchObj.operation.children.length > 0) {
                for (let i = 0; i < catchObj.operation.children.length; i++) {
                    let cur = catchObj.operation.children[i];
                    if (cur.name === 'tenantOperationTitle') { // 流程设计
                        cur.children = operationDesign.children;
                        operationDesign = cloneDeep(cur);
                    } else {
                        operationDesign.children.push(cur);
                    }
                }
                operationSonMenu.push(operationDesign);
                catchObj.operation.sonMenu = operationSonMenu;
                this.menuDataList.push(catchObj.operation);
            }
            this.addOtherMenu('2');
            let systemChildren = [];
            if (catchObj.system && catchObj.system.children.length > 0) {
                for (let i = 0; i < catchObj.system.children.length; i++) {
                    let cur = catchObj.system.children[i];
                    if (cur.name !== 'companyDetail' && cur.name !== 'departmentAdd' &&
                        cur.name !== 'positionAdd' && cur.name !== 'employeeAdd' && cur.name !== 'roleAdd' && cur.name !== 'resourceAdd') { //  流程设计
                        systemChildren.push(cur);
                    }
                }
                catchObj.system.sonMenu = systemChildren;
                this.menuDataList.push(catchObj.system);
            }
            let messageChildren = [];
            let messageDesign = {// 消息设计
                children: []
            };
            if (catchObj.message && catchObj.message.children.length > 0) {
                for (let i = 0; i < catchObj.message.children.length; i++) {
                    let cur = catchObj.message.children[i];
                    if (cur.name === 'messageDesignTitle') {
                        cur.children = messageDesign.children;
                        messageDesign = cloneDeep(cur);
                    } else if (cur.name === 'messageTemplateReceiverList') {
                        messageDesign.children.push(cur);
                    } else if (cur.name !== 'messageDetail') {
                        messageChildren.push(cur);
                    }
                }
                catchObj.message.sonMenu = messageChildren;
                this.menuDataList.push(catchObj.message);
            }
            let componentsDesign = {// 组件设计
                children: []
            };
            if (catchObj.components && catchObj.components.children.length > 0) {
                for (let i = 0; i < catchObj.components.children.length; i++) {
                    let cur = catchObj.components.children[i];
                    if (cur.name === 'componentsDesignTitle') {
                        cur.children = componentsDesign.children;
                        componentsDesign = cloneDeep(cur);
                    } else {
                        componentsDesign.children.push(cur);
                    }
                }
            }
            let applicationChildren = [];
            let applicationDesign = {// 应用设计
                children: []
            };
            if (catchObj.application && catchObj.application.children.length > 0) {
                for (let i = 0; i < catchObj.application.children.length; i++) {
                    let cur = catchObj.application.children[i];
                    if (cur.name === 'applicationDesignTitle') {
                        cur.children = applicationDesign.children;
                        applicationDesign = cloneDeep(cur);
                    } else if (cur.name === 'application-tree' || cur.name === 'model-config' || cur.name === 'model-assign') {
                        applicationDesign.children.push(cur);
                    } else if (cur.name === 'cronjob-config' || cur.name === 'notice-list') {
                        if (catchObj.office && catchObj.office.sonMenu) {
                            catchObj.office.sonMenu.push(cur);
                        }
                    }
                }
                applicationChildren.push(componentsDesign);
                applicationChildren.push(applicationDesign);
                applicationChildren.push(processDesign);
                applicationChildren.push(documentDesign);
                applicationChildren.push(messageDesign);
                catchObj.application.sonMenu = applicationChildren;
                this.menuDataList.push(catchObj.application);
            }
            this.getApplications();
            this.getAllDashBoard();
            this.workPlant = catchObj.workspace;
            // console.log(this.workPlant);
            // console.log(catchObj);
            // console.log(this.menuDataList);
        },
        addOtherMenu (o) {
            if (o === '1') { // 应用中心
                let obj = {
                    redirect: 'noredirect',
                    name: 'business',
                    isMenuWaterfall: true,
                    meta: {
                        title: '应用中心',
                        icon: 'el-icon-cpu'
                    },
                    sonMenu: [],
                    children: [
                        {
                            path: 'businessSystem',
                            name: 'businessSystem',
                            id: 'businessSystem',
                            meta: {
                                title: '应用中心',
                                icon: 'iconfont icon-other-yingyongzhongxin',
                                color: '#d81e06'
                            },
                            isShow: false,
                            isNewMenu: true,
                            isMenuWaterfall: true
                        }
                    ]
                };
                if (this.resource === '2') {
                    obj.color = 'rgb(64, 158, 255)';
                }
                // this.menuList.push(obj);
                this.menuDataList.push(obj);
            } else if (o === '2') { // 仪表盘
                let obj = {
                    redirect: 'noredirect',
                    name: 'dashboard',
                    isMenuWaterfall: true,
                    color: '',
                    meta: {
                        title: '仪表盘',
                        icon: 'el-icon-cpu'
                    },
                    sonMenu: [],
                    children: [
                        {
                            path: 'dashBoradCenter',
                            name: 'dashBoradCenter',
                            id: 'dashBoradCenter',
                            meta: {
                                title: '仪表盘',
                                icon: 'iconfont icon-other-yibiao',
                                color: '#1296db'
                            },
                            isShow: false,
                            isNewMenu: true,
                            isMenuWaterfall: true
                        }
                    ]
                };
                if (this.resource === '1') {
                    obj.color = 'rgb(64, 158, 255)';
                }
                // this.menuList.push(obj);
                this.menuDataList.push(obj);
            }
        },
        async getApplications () {
            let apps = await getPublishedApplicationList();
            this.builderApplication(apps);
        },
        async getAllDashBoard () {
            let res = await getUserWorkPlantEntry({ mode: 2 });
            if (res && res.data.length > 0) {
                this.builderDashboard(res.data);
            } else { // 假如当前用户被分配了仪表盘，但是还没有进行选择设置，这时也需要显示出仪表盘
                let param = { modelType: 5, userId: this.userInfo.userId, currentPage: 1, pageSize: 1000 };
                let res = await getModelListByType(param);
                if (res && res.data.length > 0) {
                    this.builderDashboard(res.data);
                }
            }
        },
        builderApplication (val) {
            let child = [];
            for (let i = 0; i < val.length; i++) {
                let cur = val[i];
                if (cur.category == 0) {
                    let obj = {
                        path: 'businessSystem',
                        name: 'businessSystem',
                        id: 'businessSystem',
                        meta: {
                            title: cur.label,
                            icon: 'iconfont icon-other-yingyongzhongxin',
                            color: '#d81e06'
                        },
                        title: cur.label,
                        color: '#d81e06',
                        icon: 'iconfont icon-other-yingyongzhongxin',
                        defaultAppId: cur.id,
                        isShow: false,
                        isNewMenu: true,
                        isMenuWaterfall: true
                    };
                    child.push(obj);
                }
            }
            this.menuDataList.forEach(item => {
                if (item.name === 'business') {
                    item.sonMenu = child;
                    this.menuDataList = cloneDeep(this.menuDataList);
                }
            });
        },
        builderDashboard (val) {
            let child = [];
            for (let i = 0; i < val.length; i++) {
                let cur = val[i];
                let obj = {
                    path: 'dashBoradCenter',
                    name: 'dashBoradCenter',
                    id: 'dashBoradCenter',
                    title: cur.modelName,
                    icon: 'iconfont icon-other-yibiao',
                    color: '#1296db',
                    meta: {
                        title: cur.modelName,
                        icon: 'iconfont icon-other-yibiao',
                        color: '#1296db'
                    },
                    isShow: false,
                    isNewMenu: true,
                    isMenuWaterfall: true,
                    boardCenterSelectName: JSON.stringify(cur)
                };
                child.push(obj);
            }
            this.menuDataList.forEach(item => {
                if (item.name === 'dashboard') {
                    item.sonMenu = child;
                    this.menuDataList = cloneDeep(this.menuDataList);
                }
            });
        },
        jumpUrl (val) {
            let param = {};
            if (val.defaultAppId) {
                // localStorage.setItem('defaultAppId', val.defaultAppId);
                param.appId = val.defaultAppId;
            }
            if (val.boardCenterSelectName) {
                sessionStorage.setItem('boardCenterSelectName', val.boardCenterSelectName);
            }
            let url = '/' + val.id;
            let name = val.name;
            sessionStorage.setItem('currentOpenUrl', url);// 路由定位
            localStorage.setItem('isNewPageInitLoad' + this.userInfo.userId, '1');
            this.navigateNameTo(url, name, param);
            let target = '';
            if (val.id === 'process/approvalDefinitionDesign' || val.id === 'process/processDefinitionDesign' || val.id === 'process/time-config' || val.id === 'process/close-template') {
                target = 'components';
            } else {
                target = val.id.split('/')[0];
            }
            this.handleNavPage(target, url, val.path);
        },
        jumpParentUrl (item) {
            let val = '';
            if (item.name === 'process' || item.name === 'operation' || item.name === 'application') {
                val = item.sonMenu[0].children[0];
            } else {
                val = item.sonMenu[0];
            }
            if (val.defaultAppId) {
                localStorage.setItem('defaultAppId', val.defaultAppId);
            }
            if (val.boardCenterSelectName) {
                sessionStorage.setItem('boardCenterSelectName', val.boardCenterSelectName);
            }
            let target = val.id.split('/')[0];
            setTimeout(() => {
                this.handleNavPage(target);
            }, 100);
            let url = '/' + val.id;
            let name = val.name;
            if (item.name === 'business') {
                let path = '/business/businessCenter';
                let name = 'businessCenter';
                this.navigateNameTo(path, name);
            } else {
                this.navigateNameTo(url, name);
                setTimeout(() => {
                    this.handleNavPage(target, url);
                }, 100);
            }
        }
    }
};
</script>

<style lang="less">
.navbar {
    height: 60px;
    line-height: 50px;
    border-radius: 0px !important;
    background: #ecf5ff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-menu {
        display: flex;
        align-items: center;

        .work-plant {
            .work-plant-application-top {
                display: none;
                height: auto;
                background: #FFFFFF;
                border: 1px solid #e6e6e6;
                z-index: 333;
                top: 46px;
                left: 60px;
                position: absolute;
                height: auto;
                min-height: 150px;

                .commonly-app {
                    height: 38px;
                    line-height: 38px;
                    width: 460px;
                    display: flex;
                    padding-left: 10px;
                    border-bottom: 1px solid #e3e6e6;
                }

                .work-plant-application {
                    align-content: flex-start;
                    width: auto;
                    width: 460px;
                    display: flex;
                    flex-wrap: wrap;
                    padding-bottom: 10px;

                    .application-item {
                        width: 140px;
                        display: flex;
                        margin-left: 40px;
                        cursor: pointer;

                        .icon {
                            font-size: 20px;
                            margin-top: -2px;
                        }

                        .tittle {
                            font-size: 18px;
                            width: 100px;
                        }

                        .opera {
                            .iconfont {
                                font-size: 16px;
                                margin-left: 10px;
                                color: #fc0034;
                            }
                        }
                    }

                    .application-item:hover {
                        .icon {}

                        .tittle {
                            color: #409EFF;
                        }
                    }
                }

                .work-plant-application-all {
                    align-content: flex-start;
                    width: auto;
                    width: 460px;
                    height: auto;
                    min-height: 150px;
                    z-index: 333;
                    display: flex;
                    flex-wrap: wrap;
                    padding-bottom: 10px;

                    .application-item {
                        width: 140px;
                        display: flex;
                        margin-left: 40px;
                        cursor: pointer;

                        .icon {
                            font-size: 20px;
                            margin-top: -2px;
                        }

                        .tittle {
                            font-size: 18px;
                            width: 100px;
                        }

                        .opera {
                            .iconfont {
                                font-size: 16px;
                                margin-left: 10px;
                                color: #fc0034;
                            }
                        }
                    }
                }
            }
        }

        // .work-plant:hover{
        //     .work-plant-application-top{
        //         display: block;
        //     }
        // }
    }

    .center-menu {
        display: flex;
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        background: #ecf5ff;

        .menu-system {
            flex: 1;
            display: flex;

            .menu-system-item {
                width: 100px;
                position: relative;
                text-align: center;

                .menu-system-item-child,
                .menu-system-item-child-group {
                    display: none;
                }

                @media screen and (min-width: 1024px) and (max-width: 1366px) {
                    width: 88px;
                    font-size: 16px;
                }
            }

            .menu-system-item:hover {
                background: #d4e4f5;

                .menu-system-item-child {
                    display: block;
                    z-index: 100;
                    background: #FFFFFF;
                    min-height: 100px;
                    width: 400px;
                    // max-height: 90vh;
                    overflow: auto;
                    position: absolute;
                    border: 1.2px solid #e6e3e3;
                    display: flex;
                    flex-wrap: wrap;
                    padding-bottom: 20px;
                    margin-top: -2px;
                    overflow: auto;
                    max-height: 80vh;

                    .menu-system-child {
                        min-width: 160px;
                        width: auto;
                        text-align: left;
                        height: 40px;
                        line-height: 40px;
                        padding-left: 20px;
                        cursor: pointer;
                    }

                    .menu-system-child:hover {
                        background: #d4e4f5;
                    }

                    @media screen and (min-width: 1024px) and (max-width: 1366px) {
                        position: relative;
                        right: 200px;
                    }
                }

                .menu-system-item-child-group {
                    display: block;
                    z-index: 100;
                    background: #FFFFFF;
                    min-height: 100px;
                    width: auto;
                    max-height: 90vh;
                    overflow: auto;
                    position: absolute;
                    border: 1.2px solid #e6e3e3;
                    display: flex;
                    margin-top: -2px;

                    .menu-system-child {
                        min-width: 160px;
                        width: auto;
                        text-align: left;
                        padding-left: 20px;
                        cursor: pointer;
                        font-size: 20px;

                        .iconfont {
                            font-size: 20px;
                        }

                        padding-bottom: 20px;

                        .menu-system-child-item {
                            width: 140px;
                            text-align: left;
                            height: 40px;
                            line-height: 40px;
                            padding-left: 20px;
                            cursor: pointer;
                            padding-left: 16px;
                            font-size: 16px;

                            .iconfont {
                                font-size: 16px;
                            }
                        }

                        .menu-system-child-item:hover {
                            background: #d4e4f5;
                        }
                    }
                }
            }

            .menu-system-item:last-child {
                .menu-system-item-child-group {
                    position: absolute;
                    right: -174px;
                }
            }
        }

        // align-items: center;
        // margin-top: 5px;
        // margin-right: 20px;
        // @media screen and (min-width: 1024px) and (max-width: 1366px) {
        //     .el-menu {
        //         .el-menu-item{
        //             width: 86px;
        //         }
        //         .el-submenu{
        //             width: 98px;
        //         }
        //     }
        // }
    }

    .right-menu {
        display: flex;
        align-items: center;
        margin-right: 10px;

        .item {
            margin-top: 5px;
            margin-right: 10px;

            .share-button {
                padding: 4px;
                border-radius: 10%
            }
        }

        .help {
            margin-top: 5px;
            margin-right: 20px;
            padding: 4px;
            border-radius: 10%
        }

        .userName {
            max-width: 80px;
            margin-top: 5px;
            margin-right: 10px;
            display: -webkit-box;
            /*作为弹性伸缩盒子模型显示*/
            -webkit-line-clamp: 1;
            /*显示的行数；如果要设置2行加...则设置为2*/
            overflow: hidden;
            /*超出的文本隐藏*/
            text-overflow: ellipsis;
            /* 溢出用省略号*/
            -webkit-box-orient: vertical;
            /*伸缩盒子的子元素排列：从上到下*/
        }

        .el-tag {
            margin-top: 22px;
            margin-right: 20px;
        }
    }

    .avatar-container {
        height: 50px;
        margin-right: 30px;
    }

    .avatar-wrapper {
        cursor: pointer;
        position: relative;

        .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 10px;
        }

        .el-icon-caret-bottom {
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
        }
    }

    .el-badge__content.is-fixed.is-dot {
        right: 5px;
        margin-top: 15px;
    }

    .upgrade-title {
        text-align: center;
        margin-bottom: 20px;
        color: #999;
    }

    .upgrade-body {
        background: aliceblue;
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    .demonstration {
        display: block;
        color: #8492a6;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .app-sys-item {
        white-space: nowrap;
        text-indent: 40px;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
        cursor: pointer;
        margin-top: 10px;
        opacity: 1;
    }

    .application-menu-list {
        .el-menu-item:hover {
            background-color: #d4e4f5 !important;
        }

        .el-submenu {
            .el-submenu__title:hover {
                background-color: #d4e4f5 !important;
            }
        }
    }
}

.el-menu--horizontal {
    .el-menu--popup-bottom-start {
        max-height: 80vh;
        background-color: #FFFFFF !important;

        .el-menu-item {
            background-color: #FFFFFF !important;
        }

        .el-menu-item:hover {
            background-color: rgb(236, 245, 255) !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/Navbar.vue